import React, { useEffect, useState } from 'react';
import { ErrorDPSNotWorking } from './ErrorDPSNotWorking';
import useSearchDomain from '../hooks/useSearchDomain';

interface PreviewProps {
  previewFiltersUrl: string;
  locale: string;
  tenant: string | null;
  hasError: boolean;
}

const buildPreviewUrl = (previewFiltersUrl: string, searchBaseUrl: string): string => {
  return `${searchBaseUrl}?isEmbedded&previewFilters=${encodeURIComponent(previewFiltersUrl)}`;
};

const Preview = (props: PreviewProps): React.JSX.Element => {
  const { searchBaseUrl, isLoading } = useSearchDomain(props.tenant, props.locale);

  const [previewUrl, setPreviewUrl] = useState<string>(buildPreviewUrl(props.previewFiltersUrl, searchBaseUrl));

  useEffect(() => {
    setPreviewUrl(buildPreviewUrl(props.previewFiltersUrl, searchBaseUrl));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.previewFiltersUrl, searchBaseUrl]);

  if (isLoading) {
    return (
      <div id="wrap">
        <p>Loading preview...</p>
      </div>
    );
  }

  return (
    <>
      {props.hasError ? (
        <ErrorDPSNotWorking />
      ) : (
        <div id="wrap">
          <iframe title="preview" frameBorder={0} id="frame" src={previewUrl} width="100%" height="100%"></iframe>
        </div>
      )}
    </>
  );
};

export default Preview;
